//  Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import {Component, Inject, OnInit} from '@angular/core';
import {
    IApproversStatusResult,
    SecurityApprovalMethod,
    SecurityRequestStatus
} from '../../../../types/security-requests';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import AuthHelper from '../../../auth/authHelper';

export interface ISecurityRequestStatusDialogConfig {
  results: IApproversStatusResult[];
  minimumApprovalPercentRequired: number;
  requestStatus: SecurityRequestStatus;
  securityApprovalMethod: number;
  dialogTitle: string;
  subTitle?: string;
}

@Component({
    selector: 'app-security-request-status-dialog',
    templateUrl: './security-request-status-dialog.component.html',
    styleUrls: ['./security-request-status-dialog.component.scss'],
    standalone: false
})
export class SecurityRequestStatusDialogComponent implements OnInit {
  readonly Status = SecurityRequestStatus;
  readonly userId = AuthHelper.getUidFromToken();
  securityApprovalMethodType = SecurityApprovalMethod;

  constructor(private readonly dialogRef: MatDialogRef<ISecurityRequestStatusDialogConfig>,
              @Inject(MAT_DIALOG_DATA) public data: ISecurityRequestStatusDialogConfig) { }

  ngOnInit(): void {
  }

  onButtonClick() {
    this.dialogRef.close(true);
  }

  close() {
    this.dialogRef.close();
  }
}
